import type { TaskResult } from "../types";

export async function gradeProject2(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Goal Seek en H6 → ~22.98
  await Excel.run(async (context) => {
    const sheet = context.workbook.worksheets.getItem("Ingresos de Alquiler");
    const rango = sheet.getRange("H6");
    rango.load("values");
    await context.sync();

    const valorReal = rango.values[0][0];
    const valorEsperado = 22.98036544;
    const tolerancia = 0.01;
    results.push({
      taskId: 1,
      passed: Math.abs(valorReal - valorEsperado) < tolerancia,
    });
  });

  // Tarea 2: Subtotales por ubicación
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem("Mercado Agricultores");
    const rangoUbicacion = hoja.getRange("B2:B100");
    const rangoVentas = hoja.getRange("E2:E100");
    rangoUbicacion.load("values");
    rangoVentas.load("formulas");
    await context.sync();

    const subtotalesPorUbicacion = new Set<string>();
    for (let i = 0; i < rangoVentas.formulas.length; i++) {
      const formula = rangoVentas.formulas[i][0];
      const ubicacion = rangoUbicacion.values[i][0];
      if (
        typeof formula === "string" &&
        formula.toUpperCase().startsWith("=SUBTOTAL(9,") &&
        typeof ubicacion === "string" &&
        ubicacion.startsWith("Total ")
      ) {
        subtotalesPorUbicacion.add(ubicacion.replace("Total ", "").trim());
      }
    }

    const ubicacionesEsperadas = [
      "Centro de la ciudad",
      "Parque ladera",
      "Parque norte",
      "Parque a la orilla",
      "Parque del valle",
      "Lago oeste",
    ];
    const passed = ubicacionesEsperadas.every((u) =>
      subtotalesPorUbicacion.has(u)
    );
    results.push({ taskId: 2, passed });
  });

  // Tarea 3: Corregir fórmula en C7 = C4*C5*C6
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem("Ingresos de Alquiler");
    const celda = hoja.getRange("C7");
    celda.load("formulas");
    await context.sync();

    const formula = celda.formulas[0][0];
    const formulaEsperada = "=C4*C5*C6";
    results.push({
      taskId: 3,
      passed:
        formula.toUpperCase().replace(/\s+/g, "") === formulaEsperada,
    });
  });

  // Tarea 4: Columnas B:G agrupadas y ocultas
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem("Ingresos de Alquiler");
    const columnasOcultas: Excel.Range[] = [];

    for (let i = 1; i <= 6; i++) {
      const col = hoja.getCell(0, i).getEntireColumn();
      col.load("hidden");
      columnasOcultas.push(col);
    }
    await context.sync();

    const todasOcultas = columnasOcultas.every((col) => col.hidden === true);
    results.push({ taskId: 4, passed: todasOcultas });
  });

  // Tarea 5: Campo calculado "Aumento del 3%"
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem(
      "Ventas Proyectadas (Prox. ano)"
    );
    const totalCelda = hoja.getRange("C37");
    totalCelda.load("values");
    await context.sync();

    const valorObtenido = totalCelda.values[0][0];
    const totalEsperado = 7895749;
    const tolerancia = 5;
    results.push({
      taskId: 5,
      passed: Math.abs(valorObtenido - totalEsperado) <= tolerancia,
    });
  });

  return results;
}
